import styled from "styled-components";
import { Link } from "react-router-dom";
import { theme } from "../../styles/theme";

export const FooterSection = styled("footer")`
  width: 100%;
  background: ${theme.colors.backgroundDark};
  padding: 4rem 0 2.5rem;
  color: rgba(255, 255, 255, 0.85);
`;

export const FooterGrid = styled("div")`
  display: grid;
  grid-template-columns: 2fr repeat(4, 1fr);
  gap: 2.5rem;

  @media screen and (max-width: 1100px) {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }

  @media screen and (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const FooterBrand = styled("div")``;

export const BrandName = styled("div")`
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  letter-spacing: -0.03em;
  line-height: 1.25;
  margin-bottom: 1.25rem;

  span {
    display: block;
    margin-top: 0.2rem;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: ${theme.colors.accent};
  }
`;

export const BrandDescription = styled("p")`
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.875rem;
  line-height: 1.65;
  margin-bottom: 1.5rem;
  max-width: 300px;
`;

export const FooterColumn = styled("div")``;

export const ColumnTitle = styled("h4")`
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: white;
  margin-bottom: 1.25rem;
`;

export const FooterLink = styled(Link)`
  display: block;
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.65);
  margin-bottom: 0.75rem;
  transition: color 0.2s ease;

  &:hover {
    color: ${theme.colors.accent};
  }
`;

export const Para = styled("p")`
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.875rem;
  line-height: 1.65;
  margin: 0 0 0.5rem;
`;

export const Extra = styled("section")`
  width: 100%;
  background: ${theme.colors.backgroundDark};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1.5rem 0 2rem;
`;

export const Copyright = styled("div")`
  font-size: 0.8125rem;
  color: rgba(255, 255, 255, 0.5);
`;

export const FooterContainer = styled("div")`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
`;

export const SocialLink = styled("a")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${theme.radius.sm};
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.9);
  transition: all 0.2s ease;

  .anticon {
    font-size: 1.125rem;
  }

  &:hover {
    background: ${theme.colors.primary};
    border-color: ${theme.colors.primary};
    color: ${theme.colors.white};
    transform: translateY(-2px);
  }
`;

export const ComplianceNote = styled("p")`
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.4);
  margin-top: 1.5rem;
  line-height: 1.5;
`;
